<script>
	// json解析器
	import { deepClone } from "@/components/form/utils/index";
	import render from "@/components/form/render/render.js";
	import {
		getValueStr,
		getValueItem,
	} from "@/components/form/parser/handle_sheme.js";
	import {cms_form} from '@/api/cms'
	const ruleTrigger = {
		"el-input": "blur",
		"el-input-number": "blur",
		"el-select": "change",
		"el-radio-group": "change",
		"el-checkbox-group": "change",
		"el-cascader": "change",
		"el-time-picker": "change",
		"el-date-picker": "change",
		"el-rate": "change"
	};

	const layouts = {
		// 列
		colFormItem(h, scheme) {
			const config = scheme.__config__;
			const listeners = buildListeners.call(this, scheme);
			let labelWidth = config.labelWidth ? `${config.labelWidth}px` : null;
			if (config.showLabel === false) labelWidth = "0";
			if (scheme.category == "selectBusiness") {
				return (
					<el-col span={config.span}>
						<el-form-item label-width={labelWidth} prop={scheme.__vModel__} label={config.showLabel ? config.label : ""}>
							<p>
								{config.defaultValue && config.defaultValue.length ? config.defaultValue.map((x) => x.label).join(" , ") : ""}
							</p>
							<render conf={scheme} {...{ on: listeners }} />
						</el-form-item>
					</el-col>
				);
			} else {
				return (
					<el-col span={config.span}>
						<el-form-item
							label-width={labelWidth}
							prop={scheme.__vModel__}
							label={config.showLabel ? config.label : ""}
						>
							<render conf={scheme} {...{ on: listeners }} />
							{scheme.unit ? '  ' + scheme.unit : ''}
						</el-form-item>
					</el-col>
				);
			}
		},
		// 行
		rowFormItem(h, scheme) {

			let child = renderChildren.apply(this, arguments);
			if (scheme.type === "flex") {
				child = (
					<el-row
						type={scheme.type}
						justify={scheme.justify}
						align={scheme.align}
					>
						{child}
					</el-row>
				);
			}
			return (
				<el-col span={scheme.span}>
					<el-row gutter={scheme.gutter}>{child}</el-row>
				</el-col>
			);
		},
	};

	function renderFrom(h) {
		const { formConfCopy } = this;
		return (
			<el-row gutter={formConfCopy.gutter}>
				<el-form
					size={formConfCopy.size}
					label-position={formConfCopy.labelPosition}
					disabled={formConfCopy.disabled}
					label-width={`${formConfCopy.labelWidth}px`}
					ref={formConfCopy.formRef}
					// model不能直接赋值 https://github.com/vuejs/jsx/issues/49#issuecomment-472013664
					model={this[formConfCopy.formModel]}
					rules={this[formConfCopy.formRules]}
				>
					{renderFormItem.call(this, h, formConfCopy.fields)}
					{formConfCopy.formBtns && formBtns.call(this, h)}
				</el-form>
			</el-row>
		);
	}

	function formBtns(h) {
		if (this.is_show_submit) {
			const ren = this.is_show_save ? (
				<el-col>
					<el-form-item size="large">
						<el-button onClick={this.resetForm}>重置</el-button>
						<el-button type="primary" onClick={this.saveForm}>
							保存
                    </el-button>
						<el-button type="primary" onClick={this.submitForm}>
							保存并提交
                    </el-button>
					</el-form-item>
				</el-col>
			) : (
					<el-col>
						<el-form-item size="large">
							<el-button onClick={this.resetForm}>重置</el-button>
							<el-button type="primary" onClick={this.submitForm}>
								提交申请
                    </el-button>
						</el-form-item>
					</el-col>
				);
			return ren;
		} else {
			return "";
		}
	}

	function renderFormItem(h, elementList) {
		elementList = elementList.flatMap(v => {
			if (v.list) return v.list
			else return [v]
		})

		return elementList.map((scheme) => {
			const config = scheme.__config__;
			const layout = layouts[config.layout];

			if (layout) {
				return layout.call(this, h, scheme);
			}
			throw new Error(`没有与${config.layout}匹配的layout`);
		});
	}

	function renderChildren(h, scheme) {
		const config = scheme.__config__;
		if (!Array.isArray(config.children)) return null;
		return renderFormItem.call(this, h, config.children);
	}

	function setValue(event, config, scheme) {
		this.$set(config, "defaultValue", event);
		this.$set(this[this.formConf.formModel], scheme.__vModel__, event);
		if (event) {
			//手动清除验证：针对一些控件例如上传控件
			this.clearValidByItem(scheme.__vModel__);
		}
	}

	function transfer(formModel, fields) {
		let params = {};
		fields = fields.flatMap(v => {
			if (v.list) return v.list
			else return [v]
		})
		for (let key in formModel) {
			let scheme = fields.find((v) => v.__vModel__ == key);
			if (!scheme) continue
			let str = getValueStr(scheme, formModel[key]);
			let val = getValueItem(scheme, formModel[key]);
			params[key] = {
				label: scheme.__config__.label,
				value: val,
				str: str,
				category: scheme.category,
				accept:
					scheme.category == "upload" ? scheme.accept || "file" : null,
			};
		}
		return params;
	}

	function buildListeners(scheme) {
		const config = scheme.__config__;
		const methods = this.formConf.__methods__ || {};
		const listeners = {};

		// 给__methods__中的方法绑定this和event
		Object.keys(methods).forEach((key) => {
			listeners[key] = (event) => methods[key].call(this, event);
		});
		// 响应 render.js 中的 vModel $emit('input', val)
		listeners.input = (event) => setValue.call(this, event, config, scheme);

		// listeners.getResponse = (event) => getResponse.call(this, event, config, scheme);
		return listeners;
	}

	export default {
		components: {
			render,
		},
		props: {
			formConf: {
				type: Object,
				required: true,
			},
			is_show_save: {
				type: Boolean,
				default: false,
			},
			is_show_submit: {
				type: Boolean,
				default: true,
			},
		},
		data() {
			const data = {
				formConfCopy: deepClone(this.formConf),
				[this.formConf.formModel]: {},
				[this.formConf.formRules]: {},
			};
			this.initFormData(
				data.formConfCopy.fields,
				data[this.formConf.formModel]
			);
			this.buildRules(
				data.formConfCopy.fields,
				data[this.formConf.formRules]
			);
			return data;
		},
		methods: {
			initFormData(componentList, formData) {
				componentList.forEach((cur) => {
					const config = cur.__config__;
					if (cur.__vModel__)
						formData[cur.__vModel__] = config.defaultValue;
					if (config.children)
						this.initFormData(config.children, formData);
				});
			},
			buildRules(componentList, rules) {
				componentList.forEach((cur) => {
					const config = cur.__config__;
					if (Array.isArray(config.regList)) {
						if (config.required) {
							const required = {
								required: config.required,
								message: cur.placeholder,
							};
							if (Array.isArray(config.defaultValue)) {
								required.type = "array"
								required.message = `请至少选择一个${config.label}`
							}
							required.message === undefined &&
								(required.message = `${config.label}不能为空`);
							config.regList.push(required);
						}
						rules[cur.__vModel__] = config.regList.map((item) => {
							item.pattern && (item.pattern = eval(item.pattern));
							item.trigger = ruleTrigger && ruleTrigger[config.tag];
							return item;
						});
						console.log('=====>rules',rules)
					}
					if (config.children) this.buildRules(config.children, rules);
				});
			},

			clearValidByItem(prop) {
				this.$nextTick((_) => {
					this.$refs[this.formConf.formRef].clearValidate(prop);
				});
			},

			resetForm() {
				this.formConfCopy = deepClone(this.formConf);
				this.$refs[this.formConf.formRef].resetFields();
				this.$refs[this.formConf.formRef].clearValidate(); //重置时清空验证错误码
			},
			submitForm() {
				//保存并提交
				this.$refs[this.formConf.formRef].validate((valid) => {
					if (!valid) return false;
					this.$emit("submit",
						transfer(
							this[this.formConf.formModel],
							this.formConf.fields
						)
					);
					return true;
				});
			},
			saveForm() {
				//仅保存
				this.$refs[this.formConf.formRef].validate((valid) => {
					if (!valid) return false;
					this.$emit(
						"save",
						transfer(
							this[this.formConf.formModel],
							this.formConf.fields
						)
					);
					return true;
				});
			},
		},
		mounted(){
		
			this.formConfCopy.fields.forEach(c=>{
				if(c.__config__.datasource){
					cms_form.getOptions({id:c.__config__.datasource,field:c.__vModel__}).then(res=>{
						let r= this.formConfCopy.fields.find(v=>v.__vModel__==res.data.field)
						r.__slot__.options=res.data.list
					})
				}
			})
		},
		render(h) {
			return renderFrom.call(this, h);
		},


	};
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/form/parser/Parser.vue